import { Box,  } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DownloadBox = styled(Box)(({ theme }) => ({
  border: `2px solid ${theme.palette.grey[300]}`,
  color: theme.palette.text.secondary,
  borderRadius: "10px",
}));
